import { OpsiumUserShort } from '@/modules/common/types/opsium-user';
import { TimeOffTypeCode } from '@/modules/common/types/time-off-type';

import { PartOfDay } from './time-off-part-of-day';
import { TimeOffStatus } from './time-off-status';
import { TimeOffTimeCategory } from './time-off-time-category';

export enum ApprovalStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
}

/**
 * Where this approver's step stands in the sequential approval chain — distinct from
 * {@link ApprovalStatus}, which only carries the raw decision. A still-PENDING step is either
 * `AwaitsResponse` (this approver's turn now) or `Blocked` (queued behind an earlier approver).
 */
export enum ApprovalStepStatus {
  AwaitsResponse = 'AWAITS_RESPONSE',
  Blocked = 'BLOCKED',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
}

export enum TimeOffRequestAllowedAction {
  EDIT = 'EDIT',
  CANCEL = 'CANCEL',
}

export interface TimeOffRequestApprover {
  user: OpsiumUserShort;
  status: ApprovalStatus;
  stepStatus: ApprovalStepStatus;
  decidedAt: string | null;
  comment: string | null;
}

export interface TimeOffRequestType {
  id: number;
  code: TimeOffTypeCode | null;
  displayName: string;
}

export enum DayPortion {
  Full = 'FULL',
  Half = 'HALF',
  Quarter = 'QUARTER',
  Hourly = 'HOURLY',
}

export interface TimeOffRequestDay {
  date: string;
  partOfDay: PartOfDay;
  portion: DayPortion;
  /** Minutes off for the day — only meaningful (non-null) for HOURLY portions. */
  minutes: number | null;
}

export interface TimeOffRequest {
  id: number;
  type: TimeOffRequestType;
  status: TimeOffStatus;
  startDate: string;
  endDate: string;
  totalDays: number;
  days: TimeOffRequestDay[];
  partOfDay: PartOfDay;
  approvers: TimeOffRequestApprover[];
  requestedBy: OpsiumUserShort;
  timeCategory: TimeOffTimeCategory;
  description: string | null;
  allowedActions: TimeOffRequestAllowedAction[];
  requestedAt: string;
  approvedAt: string | null;
}
